import { render, staticRenderFns } from "./OtpValidation.vue?vue&type=template&id=1aef73ce&scoped=true"
import script from "./OtpValidation.vue?vue&type=script&lang=ts"
export * from "./OtpValidation.vue?vue&type=script&lang=ts"
import style0 from "./OtpValidation.vue?vue&type=style&index=0&id=1aef73ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef73ce",
  null
  
)

export default component.exports